import { makeHTTP } from "@twiage/http";
import type { Options } from "@twiage/http/types/Options";

import { getJWTToken } from "./get-jwt-token";

export let http: ReturnType<typeof makeHTTP>;

export const initHTTP = ({
  prefixURL = "",
}: {
  prefixURL: Options["prefixUrl"];
}) => {
  http = makeHTTP({
    options: {
      hooks: {
        beforeRequest: [
          (request) => {
            request.headers.set("Authorization", `JWT ${getJWTToken()}`);
          },
        ],
      },
      prefixUrl: prefixURL,
      timeout: 180000,
    },
  });
};
